module.exports = __webpack_public_path__ + "static/media/tab.3f014cd0.png";